<template>
<vx-card class="w-full">
  <input id='fileinputtk' type='file' accept='.csv' @change="readCSV($event, prospectsURLs)" style="display: none;" />
  <vs-popup :active.sync="showDisplaySERPsPopup" :title="'SERPs du prospect'">
    <!-- selectedProspect -->
    <div style="width: 600px;">
      <vs-table noDataText="Aucune données, ajoutez des mots-clés ou prospects et revenez plus tard." :data="selectedProspect" stripe auto-resize>
        <template slot="thead">
            <vs-th>Keyword</vs-th>
            <vs-th>Position</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :key="index" v-for="(onePs, index) in data.serp_data">
              <vs-td><span>{{ onePs.keyword }}</span></vs-td>
              <vs-td><span>{{ onePs.position > 0 ? onePs.position : "ABS" }}</span></vs-td>
            </vs-tr>
          </template>
      </vs-table>
    </div>
  </vs-popup>
  <vs-popup :active.sync="showModifyURLPopup" :title="'Modification du prospect'">
    <div style="width: 1000px;">
      <vs-input
        class="w-full"
        v-model="modifiedURL"
      />
      <vs-button @click="modifyURL">Enregistrer</vs-button>
    </div>
  </vs-popup>
  <div class="vx-col w-full">
    <div class="vx-row w-full">
      <div class="vx-col sm:w-1/2 w-full mb-2">
        <h3>Modification de Recherche de Prospects</h3>
      </div>
      <!-- BOUTON DE RETOUR : TODO : CHANGER LES CONDITIONS -->
      <div class="vx-col sm:w-1/2 w-full mb-2">
        <vs-button
          class="float-right"
          radius
          color="primary"
          type="filled"
          icon-pack="feather"
          icon="icon-x"
          @click="returnPrevRoute"
        ></vs-button>
      </div>
      <!-- /BOUTON DE RETOUR -->
    </div>
    <div class="vx-row w-full mb-2">
      <vx-card>
        <div class="vx-row">
          <div class="vx-col">
            <vs-input
              class="w-full"
              label="Nom de la recherche"
              placeholder="Ma recherche 1"
              v-model="prospectSearch.name"
              disabled
            />
          </div>
          <div class="vx-col">
            <vs-input
              class="w-full"
              label="Domaine d'activité"
              placeholder="Référencement"
              v-model="prospectSearch.domain_activity"
              disabled
            />
          </div>
        </div>
      </vx-card>
    </div>
    <div class="vx-row mb-2">
      <vx-card>
        <div v-if="$acl.check('accountmanager')" class="vx-col"><vs-button icon-pack="feather" icon="icon-download-cloud" color="dark" @click="exportData(prospects)">Exporter</vs-button></div>
        <vs-table v-if="prospectSearch" noDataText="Aucune données, ajoutez des mots-clés ou prospects et revenez plus tard." :data="prospects" stripe auto-resize>
          <template slot="thead">
            <vs-th>URL</vs-th>
            <vs-th>Position moyenne</vs-th>
            <vs-th>DA</vs-th>
            <vs-th>PA</vs-th>
            <vs-th>Domaines Référents</vs-th>
            <vs-th>Liens entrants</vs-th>
            <vs-th>Trust flow</vs-th>
			<vs-th>Nom TTF0</vs-th>
			<vs-th>Valeur TTF0</vs-th>
			<vs-th>Nom TTF1</vs-th>
			<vs-th>Valeur TTF1</vs-th>
			<vs-th>Nom TTF2</vs-th>
			<vs-th>Valeur TTF2</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :key="index" v-for="(onePs, index) in data">
              <vs-td><span>{{ onePs.url }}</span></vs-td>
              <vs-td><span class="hvr-underline hvr-underline-out" @click="displayDisplaySERPs(onePs)">{{ onePs.avg_pos }}</span></vs-td>
              <vs-td><span>{{ onePs.domain_authority }}</span></vs-td>
              <vs-td><span>{{ onePs.page_authority }}</span></vs-td>
              <vs-td><span>{{ onePs.referring_domains }}</span></vs-td>
              <vs-td><span>{{ onePs.referring_links }}</span></vs-td>
              <vs-td><span>{{ onePs.trust_flow }}</span></vs-td>
              <vs-td><span>{{ onePs.ttf0_name }}</span></vs-td>
              <vs-td><span>{{ onePs.ttf0_value }}</span></vs-td>
              <vs-td><span>{{ onePs.ttf1_name }}</span></vs-td>
              <vs-td><span>{{ onePs.ttf1_value }}</span></vs-td>
              <vs-td><span>{{ onePs.ttf2_name }}</span></vs-td>
              <vs-td><span>{{ onePs.ttf2_value }}</span></vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
    </div>
    <div class="vx-row w-full">
      <div class="vx-col w-1/2">
        <vx-card :title="'Editer les prospects'">
          <div v-if="$acl.check('accountmanager')" class="vx-col"><vs-button @click="csvImport">Importer CSV</vs-button></div>
          <vs-table  noDataText="Entrez au moins une URL de prospect" :data="prospectsURLs">
            <template slot="thead">
              <vs-th>URL</vs-th>
              <vs-th></vs-th>
              <vs-th></vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr v-for="(row, index) in data" :key="index">
              <vs-td>{{row}}</vs-td>
              <vs-td>
                <vx-tooltip text="Modifier" position="top">
                  <vs-button size="large"
                            color="primary"
                            type="flat"
                            icon-pack="feather"
                            icon="icon-edit-2"
                            @click="updateURL(index, row)"></vs-button>
                </vx-tooltip>
              </vs-td>
              <vs-td>
                <vx-tooltip text="Effacer" position="top">
                  <vs-button size="large"
                            color="danger"
                            type="flat"
                            icon-pack="feather"
                            icon="icon-trash-2"
                            @click="prospectsURLs.splice(index,1)"></vs-button>
                </vx-tooltip>
              </vs-td>
              </vs-tr>
            </template>
          </vs-table>
          <div v-if="showAddURL">
            <div>
              <vs-input
                class="w-full"
                placeholder="https://www.yoursite.com"
                v-model="newUrl"
              />
            </div>
            <div><vs-button @click="addURL(newUrl)">Ajouter</vs-button></div>
          </div>
          <div v-else>
            <vs-button
              class="float-right"
              radius
              color="primary"
              type="filled"
              icon-pack="feather"
              icon="icon-plus"
              @click="displayAddUrl"
            ></vs-button>
          </div>
        </vx-card>
      </div>
      <div class="vx-col w-1/2" v-show="showModifyTopKeywords == true"><TopKeywordEditor ref="topKeywordsEditor" :topKeywords="topKeywords" @updated-top-keywords="updateAndHideModifyTopKeywords($event)" @close-popup="cancelAndHideModifyTopKeywords" /></div>
      <div v-show="showModifyTopKeywords == false" class="vx-col w-1/2">
        <div class="mb-2"><vs-button @click="displayModifyTopKeywords">Ajouter des Top Keywords</vs-button></div>
        <div>
          <vs-chip :key="index" v-for="(keyword,index) of topKeywords">{{ keyword }}</vs-chip>
        </div>
      </div>
    </div>

    <div class="vx-row float-right mt-3">
      <div class="vx-col w-full">
        <vs-button v-if="checkRequiredFields()" @click="submitProspectSearch" class="mb-2">Enregistrer</vs-button>
      </div>
    </div>
  </div>
  </vx-card>
</template>

<script>
import VueCookies from "vue-cookies";
import TopKeywordEditor from "@/components/views/dashboard/keywords/TopKeywordEditor";

import ProspectSearch from "@/entities/ProspectSearch";

import store from "@/store/store";
import XLSX from "xlsx";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";

export default {
	name: "UpdateProspectForm",
	mixins: [dbFieldConvertor],
	props: {
		chartParams: Object,
		isPercent: Boolean,
		type: String,
	},
	components: {
		flatPickr,
		TopKeywordEditor
	},
	data() {
		return {
			apiUrl: this.$store.state.backendApiUrl,

			prospectSearch: ProspectSearch.getFormFields(),
			topKeywords: [],
			showModifyTopKeywords: false,

			prospects: [],
			prospectsURLs: [],
			showAddURL: false,
			newUrl: "",

			showModifyURLPopup: false,
			modifiedURL: "",
			modifiedURLIndex: null,

			prospectSERPs: [],
			showDisplaySERPsPopup: false,
			selectedProspect: null,
		};
	},
	created() {
		//
		this.$http.get(this.apiUrl + "ps/getfull/" + this.$route.params.psId)
			.then(ps => {
				this.prospectSearch = new ProspectSearch(ps.data[0]);
				this.prospectSearchOld = new ProspectSearch(ps.data[0]);

				try{
					this.prospects = this.prospectSearch.prospect_list ? JSON.parse(this.prospectSearch.prospect_list) : [];
					this.prospectsURLs = this.prospects.length > 0 ? this.prospects.map(row => row.url) : [];
					this.prospectSERPs = this.prospectSearch.serp_list ? JSON.parse(this.prospectSearch.serp_list) : [];
					if(this.prospectSERPs.length > 0){
						for(let i = 0; i < this.prospects.length; i++){
							let filteredProspectSERPs = this.prospectSERPs.filter(row => row.prospect_id == this.prospects[i].id);
							this.prospects[i].serp_data = filteredProspectSERPs.length > 0 ? filteredProspectSERPs : [];
							let prospectAvgPos = 0;
							if(filteredProspectSERPs.length > 0){
								for(let j = 0; j < filteredProspectSERPs.length; j++){
									let position = parseInt(filteredProspectSERPs[j].position) == 0 ? 100 : parseInt(filteredProspectSERPs[j].position);
									prospectAvgPos += position;
								}
								prospectAvgPos = Math.round(prospectAvgPos / filteredProspectSERPs.length);
							}
							this.prospects[i].avg_pos = prospectAvgPos;
						}
					}
					this.topKeywords = this.prospectSearch.keyword_list ? this.prospectSearch.keyword_list.split(",") : [];
				}
				catch(e){
					//console.log(e);
				}

			})
			.catch(err => {
				//console.log(err);
			});
	},
	computed: {
		activeUser: () => {
			return VueCookies.get("userInfo");
		}
	},
	watch: {

	},
	methods: {
		exportData(data){
			// let today =
			let wb = XLSX.utils.book_new();
			let ws_name = "Prospects";

			let header = {
				header: [
					"url",
					"domain_authority",
					"page_authority",
					"referring_domains",
					"referring_links",
					"trust_flow",
					"ttf0_name",
					"ttf0_value",
					"ttf1_name",
					"ttf1_value",
					"ttf2_name",
					"ttf2_value"
				],
				skipHeader: true,
				origin: -1
			};

			let header_names = [{
				url: "url",
				domain_authority: "DA",
				page_authority: "PA",
				referring_domains: "Domaines référents",
				referring_links: "Liens entrants",
				trust_flow: "Trust flow",
				ttf0_name: "Nom TTF0",
				ttf0_value: "Valeur TTF0",
				ttf1_name: "Nom TTF1",
				ttf1_value: "Valeur TTF1",
				ttf2_name: "Nom TTF2",
				ttf2_value: "Valeur TTF2"
			}];
			let formated_data = [];
			for(let i = 0; i < data.length; i++){
				formated_data.push({
					url: data[i].url,
					domain_authority: data[i].domain_authority,
					page_authority: data[i].page_authority,
					referring_domains: data[i].referring_domains,
					referring_links: data[i].referring_links,
					trust_flow: data[i].trust_flow,
					ttf0_name: data[i].ttf0_name,
					ttf0_value: data[i].ttf0_value,
					ttf1_name: data[i].ttf1_name,
					ttf1_value: data[i].ttf1_value,
					ttf2_name: data[i].ttf2_name,
					ttf2_value: data[i].ttf2_value
				});
			}

			let ws = XLSX.utils.json_to_sheet(header_names, header);
			XLSX.utils.sheet_add_json(ws, formated_data, header);

			/* Add the worksheet to the workbook */
			XLSX.utils.book_append_sheet(wb, ws, ws_name);

			XLSX.writeFile(wb, "Prospects_export.xls");
		},

		addUrls(urls){
			for(let url of urls){
				if(this.prospectsURLs.includes(url.toLowerCase()) == false){
					this.prospectsURLs.push(url.toLowerCase());
				}
			}
		},
		csvImport(){
			//console.log("csvImport");
			let inputFile = document.getElementById("fileinputtk");
			//console.log(inputFile);
			inputFile.click();
		},
		readCSV(file, prospectsURLs){
			/*
			 * //console.log("file", file.target.result)
			 * //console.log("file", file.target.files[0])
			 */
			let reader = new FileReader();
			const callback = this.addUrls;
			reader.onload = function(e) {
				let mergedURLs = [];
				let data = new Uint8Array(e.target.result);
				let workbook = XLSX.read(data, {type: "array"});
				/* DO SOMETHING WITH workbook HERE */
				let sheet_name_list = workbook.SheetNames;
				let fetched_URLs = XLSX.utils.sheet_to_json(workbook.Sheets[sheet_name_list[0]], {raw: true, defval: null});
				// //console.log("fetched_competitors", fetched_competitors)
				if(fetched_URLs.length > 0){
					mergedURLs = [...prospectsURLs];
					// //console.log("mergedURLs", mergedURLs)
					fetched_URLs.forEach(row => {
						if(row.url && row.url !== null){
							if(!mergedURLs.includes(row.url)) mergedURLs.push(row.url);
							// //console.log("mergedURLs updated", mergedURLs)
						}
					});
					//console.log(mergedURLs);
					// let stringMergedKeywords = mergedURLs.join(',')
					callback(mergedURLs);
				}
			};
			reader.readAsArrayBuffer(file.target.files[0]).result;
			/*
			 * //console.log("mergedURLs updated 2", this.mergedURLs) // REPLACE WITH A DISPLAY SHOWING NEWLY IMPORTED KEYWORDS AND VALIDATE
			 * this.onSaveTke(this.mergedURLs)
			 */
		},

		submitProspectSearch(){
			this.prospectSearch.updateProspects(this.prospectsURLs, (errUpdateProspects, resultUpdateProspects) => {
				if(errUpdateProspects){
					//console.log(errUpdateProspects);
				}
				if(resultUpdateProspects){
					if(this.topKeywords.length > 0){
						this.prospectSearch.updateKeywords(this.topKeywords, (errUpdateKeywords, resultUpdateKeywords) => {
							if(errUpdateKeywords){
								// NOTIFY FAILED
								return;
							}
							if(resultUpdateKeywords){
								/*
								 * NOTIFY OK + WAIT A BIT
								 * RETURN PREVIOUS PAGE
								 */
								this.returnPrevRoute();
							}
						});
					}
					else{
						this.returnPrevRoute();
					}
				}
			});
			// let prospectSearchObject = new ProspectSearch(this.prospectSearch)
			// // ADD USER_ID
			// prospectSearchObject.user_id = this.activeUser.id
			// prospectSearchObject.create((errCreatePS, ps_id) => {
			//   if(errCreatePS){
			//     // NOTIFY FAILED
			//     return
			//   }
			//   if(ps_id){
			//     prospectSearchObject.id = ps_id
			//     prospectSearchObject.updateProspects(this.prospectsURLs, (errUpdateProspects, resultUpdateProspects) => {
			//       if(errUpdateProspects){
			//         // NOTIFY FAILED
			//         return
			//       }
			//       if(resultUpdateProspects){
			//         prospectSearchObject.updateKeywords(this.topKeywords, (errUpdateKeywords, resultUpdateKeywords) => {
			//           if(errUpdateKeywords){
			//             // NOTIFY FAILED
			//             return
			//           }
			//           if(resultUpdateKeywords){
			//             // NOTIFY OK + WAIT A BIT
			//             // RETURN PREVIOUS PAGE
			//             this.returnPrevRoute()
			//           }
			//         })
			//       }
			//     })
			//   }
			// })
			// CREATE PROSPECTSEARCH
			// ADD PROSPECTS
			// ADD KEYWORDS

			// //console.log("submitProspectSearch")
		},

		checkRequiredFields(){
			let requiredOk = true;
			if(this.showModifyTopKeywords == true) requiredOk = false;
			if(this.prospectsURLs.length < 1) requiredOk = false;
			if(this.topKeywords.length < 1) requiredOk = false;

			return requiredOk;
		},

		displayModifyTopKeywords(){
			this.showModifyTopKeywords = true;
			this.$refs.topKeywordsEditor.setTopKeywords();
		},

		displayDisplaySERPs(selectedProspect){
			this.showDisplaySERPsPopup = true;
			this.selectedProspect = selectedProspect;
		},


		updateAndHideModifyTopKeywords(tks){
			this.topKeywords = tks.split(",");
			this.showModifyTopKeywords = false;
		},
		cancelAndHideModifyTopKeywords(){
			this.showModifyTopKeywords = false;
		},
		addURL(url){
			this.prospectsURLs.push(url);
			this.showAddURL = false;
		},
		displayAddUrl(){
			this.showAddURL = true;
		},

		updateURL(index, row){
			this.modifiedURL = row;
			this.modifiedURLIndex = index;
			this.showModifyURLPopup = true;
		},
		modifyURL(){
			this.prospectsURLs[this.modifiedURLIndex] = this.modifiedURL;
			this.showModifyURLPopup = false;
		},

		/**
		 * Redirect to the previous page
		 */
		returnPrevRoute() {
			this.$router.go(-1);
		},
	}
};
</script>

<style scoped>
.hvr-underline-out{
  color: black;
}
.hvr-underline:hover{
  color:aqua;
  text-decoration: underline;
  cursor: pointer;
}
.role_selector_container {
  justify-content: space-between;
  width: 40%;
}

.role_container {
  justify-content: center;
}

.space_div {
  margin: 5px;
}

</style>
